import React, { Component, Fragment } from 'react'
import { WhiteTable } from 'Common/styled'
import { Col, Input, Row, Select } from 'antd'
import FormItem from 'Components/FormItem'
import * as _ from 'lodash'

// Refs list is not real data
import { formats, gamma, refsTableLocale } from 'Common/constants'
import { connect } from 'react-redux'
import { numeral } from 'Common/global'
import api from '../../common/api';

class RefsTable extends Component {
  state = {
    storeIds: [],
    selectedRefs: [],
    refNumFilter: "",
    descriptionFilter: "",
    gammaFilter: "",
    filteredRefs: [],
    currentPage: 1,
    pageSize: 10
  }

  collector = {
    stores: null,
    details: null
  }

  constructor(props) {
    super(props);
    this.stocksRef = React.createRef();
  }

  componentDidMount() {
    // if (this.props.isNewAgreement) {
    //   this.collector.stores = 'newAgreementStores';
    //   this.collector.details = 'newAgreementDetails';
    // } else {
    //   this.collector.stores = 'selectedAgreementStores';
    //   this.collector.details = 'selectedAgreementDetails';
    // }

    this.filterRefs();

    this.setState({
      selectedRefs: _.get(this.props, 'selectedRefs', []),
    });

    /*this.rowSelection.onSelect = this.rowSelection.onSelect.bind(this);
    this.rowSelection.onSelectAll = this.rowSelection.onSelectAll.bind(this);
    this.rowSelection.getCheckboxProps = this.rowSelection.getCheckboxProps.bind(this);*/
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.references.length !== prevProps.references.length) {
        this.filterRefs();
    }

    //TODO: review this function

    // if (prevProps[this.collector.stores] !== this.props[this.collector.stores]) {
    //   const storeIds = []
    //
    //   _.forEach(this.props[this.collector.stores], store => {
    //     storeIds.push(Number(store.storeCode))
    //   });
    //
    //   this.setState({ storeIds: storeIds })
    // }
    //
    if ((prevProps.selectedRefs.length !== 0 || this.props.selectedRefs.length !== 0) && prevProps.selectedRefs !== this.props.selectedRefs) {
      this.setState({
        selectedRefs: _.get(this.props, 'selectedRefs', [])
      }, () => {
        if (this.props.references.length && (prevState.selectedRefs.length !== 0 || this.state.selectedRefs.length !== 0) && prevState.selectedRefs !== this.state.selectedRefs) {
          const records = _.filter(this.props.references, o => {
            return this.state.selectedRefs.indexOf(o.reference) > -1;
          });

          let data = this.props.isNewAgreement ? this.props.newAgreementDetails : this.props.selectedAgreementDetails;
          // let recordBuild;

          for (let record of records) {
            const builtRecord = this.buildAgreementDetailFromRecord(record);

            if (_.findIndex(data, { refLm: builtRecord.refLm }) > -1) {
              continue;
            }

            data.push(this.buildAgreementDetailFromRecord(record));
          }

          data = _.filter(data, o => {
            return this.state.selectedRefs.indexOf(o.refLm) > -1;
          });

          this.props.onChangeCallback({ agreementDetails: data });
        }
      })
    } else {
      if (this.props.references.length && (prevState.selectedRefs.length !== 0 || this.state.selectedRefs.length !== 0) && prevState.selectedRefs !== this.state.selectedRefs) {
        const records = _.filter(this.props.references, o => {
          return this.state.selectedRefs.indexOf(o.reference) > -1;
        });

        let data = this.props.isNewAgreement ? this.props.newAgreementDetails : this.props.selectedAgreementDetails;
        // let recordBuild;

        for (let record of records) {
          const builtRecord = this.buildAgreementDetailFromRecord(record);

          if (_.findIndex(data, { refLm: builtRecord.refLm }) > -1) {
            continue;
          }

          data.push(this.buildAgreementDetailFromRecord(record));
        }

        data = _.filter(data, o => {
          return this.state.selectedRefs.indexOf(o.refLm) > -1;
        });

        this.props.onChangeCallback({ agreementDetails: data });
      }
    }

  }

  columns = [
    {
      title: 'Ref. LM',
      dataIndex: 'reference',
      key: 'reference'
    },
    {
      title: 'Descrizione',
      dataIndex: 'desc',
      key: 'desc'
    },
    {
      title: 'Gamma',
      dataIndex: 'gamma',
      key: 'gamma'
    },
    {
      title: 'N. negozi',
      dataIndex: 'stock',
      key: 'StoresNumber',
      render: record => {
        return this.getStoresNumberItem(record)
      }
    },
    {
      title: 'Qtà Stock',
      dataIndex: 'stock',
      key: 'stock',
      render: record => {
        return this.getStockItem(record)
      }
    },
    {
      title: 'Prezzo',
      dataIndex: 'price',
      key: 'price',
      render: value => {
        return numeral(value).format(formats.currency);
      }
    },
    {
      title: 'Totale',
      dataIndex: 'stock',
      key: 'totalAmount',
      render: (record, item) => {
        return this.getTotalItem(record, item)
      }
    }
  ];

  buildAgreementDetailConnectionFromStock = stock => {
    const row = {
      storeStock: 0,
      proposedStock: 0,
      acceptedStock: 0,
      realStock: 0,
      withdrawnStock: 0,
      shippedStock: 0,
      deliveredStock: 0,
      storeId: null,
      storeName: null,
    };

    row.storeStock = numeral(numeral(_.get(stock, 'qty', 0)).format(formats.number)).value();
    row.proposedStock = row.storeStock;
    row.acceptedStock = row.storeStock;
    row.storeId = _.get(stock, 'store', null);
    row.storeName = _.get(_.find(this.props.stores, { 'storeCode': row.storeId }), 'storeDesc', null);

    return row
  };

  componentWillMount() {
    if (this.props.isProposal === true) {
      this.columns = _.filter(this.columns, o => o.key !== 'StoresNumber');
    }
  }

  buildAgreementDetailFromRecord = record => {
    const allStores = this.props.selectedStores.indexOf(0) > -1;
    // const stocks = _.filter(record.stock, o => {
    //   return this.props.selectedStores.indexOf(o.store) > -1 || allStores
    // });

    const refStocks = _.get(this.stocksRef.current, record.reference, {});

    const stocks = Object.keys(refStocks)
      .filter(storeId => this.props.selectedStores.indexOf(Number(storeId)) > -1 || allStores)
      .map(storeId => ({
        qty: _.get(refStocks, storeId, 0),
        store: Number(storeId),
      }));

    console.log(stocks);

    const row = {
      acceptedPrice: 0,
      acceptedQuantity: 0,
      description: null,
      price: 0,
      gamma: null,
      letterRange: null,
      maxQuantity: 0,
      nomencCodRay: null,
      nomencCodSray: null,
      nomencCodType: null,
      nomenclature: null,
      notes: null,
      proposedPrice: record.price,
      proposedQuantity: this.getStockItem(record.stock),
      refLm: null,
      eanCode: null,
      storesNumber: 0,
      totalAmount: 0,
      discount: 0,
      connections: []
    };

    let oldRef = _.find(this.props.selectedAgreementDetails, function (o) { return o.eanCode === record.ean; });

    if (oldRef) {
      row.acceptedPrice = oldRef.acceptedPrice
      row.discount = oldRef.discount
      row.proposedPrice = oldRef.proposedPrice
    } else {
      row.acceptedPrice = numeral(numeral(_.get(record, 'price', row.acceptedPrice)).format(formats.currency)).value();
      row.discount = numeral(numeral(_.get(record, 'discount', row.discount)).format(formats.percentage)).value();
      row.proposedPrice = numeral(numeral(_.get(record, 'price', row.proposedPrice)).format(formats.currency)).value();
    }
    row.description = _.get(record, 'desc', row.description);
    row.eanCode = _.get(record, 'ean', row.eanCode);
    row.price = numeral(numeral(_.get(record, 'price', row.price)).format(formats.currency)).value();
    row.refLm = _.get(record, 'reference', row.refLm);
    row.storesNumber = _.size(stocks);
    row.gamma = _.get(record, 'gamma', row.gamma);

    _.forEach(stocks, stock => {
      row.maxQuantity += Number(stock.qty);
      row.connections.push(this.buildAgreementDetailConnectionFromStock(stock));
    });

    row.maxQuantity = numeral(numeral(row.maxQuantity).format(formats.number)).value();
    row.proposedQuantity = row.maxQuantity;
    row.acceptedQuantity = row.maxQuantity;
    row.totalAmount = numeral(numeral(row.price * row.maxQuantity).format(formats.price)).value();

    return row;
  };

  getStockItem(record) {
    let stock = 0
    const allStores = this.props.selectedStores.indexOf(0) > -1

    record.forEach((elem) => {
      if (this.props.selectedStores.indexOf(elem.store) === -1 && !allStores) {
        return
      }

      stock += parseFloat(elem.qty)
    });

    return numeral(stock).format(formats.number);
  }

  getStoresNumberItem(record) {
    const allStores = this.props.selectedStores.indexOf(0) > -1
    const records = _.filter(record, o => {
      return this.props.selectedStores.indexOf(o.store) > -1 || allStores
    });

    return numeral(_.size(records)).format(formats.int);
  }

  getTotalItem(record, item) {
    const totalStock = numeral(this.getStockItem(record));

    if (totalStock.value() === null) {
      console.warn('Total stock is: ', totalStock.value());
      return totalStock.format(formats.currency)
    }

    const price = numeral(item.price)

    if (price.value() === null) {
      console.warn('Price is: ', price.value())
      return price.format(formats.currency);
    }

    return numeral(totalStock.value() * price.value()).format(formats.currency);
  }

  setRefNumFilter = e => {
    this.setState({ refNumFilter: e.target.value, currentPage: 1 })
    setTimeout(() => {
      this.filterRefs();
    });
  }

  setDescriptionFilter = e => {
    this.setState({ descriptionFilter: e.target.value, currentPage: 1 })
    setTimeout(() => {
      this.filterRefs();
    });
  }

  setGammaFilter = value => {
    this.setState({ gammaFilter: value, currentPage: 1 })
    setTimeout(() => {
      this.filterRefs();
    });
  }

  filterRefs = () => {
    let refNumFilter = this.state.refNumFilter
    let descriptionFilter = this.state.descriptionFilter.toLowerCase()
    let gammaFilter = this.state.gammaFilter

    const records = this.props.references.filter(ref => {
      let show = true
      if (refNumFilter !== "" && !ref.reference.startsWith(refNumFilter)) {
        show = false
      }
      if (descriptionFilter !== "" && !ref.desc.toLowerCase().includes(descriptionFilter)) {
        show = false
      }
      if (gammaFilter !== "" && ref.gamma !== gammaFilter) {
        show = false
      }
      return show
    });

    this.setState({
      filteredRefs: [...records]
    });

    setTimeout(() => {
      this.handleStockChange();
    });
  }

  handleStockChange = () => {
    const { filteredRefs, currentPage, pageSize } = this.state;
    const { selectedStores, stores } = this.props;

    if (filteredRefs.length === 0) {
      return;
    }

    if (stores.length === 0) {
      return;
    }

    const nextPageProductIds = filteredRefs.slice((currentPage - 1) * pageSize, currentPage * pageSize).map(ref => ref.reference);

    let storeIds;

    if (selectedStores.length > 0) {
      storeIds = selectedStores;
    } else {
      storeIds = stores.map(store => store.storeCode);
    }

    const storeChunkSize = 20;
    const storeIdsChunks = [];


    for (let i = 0; i < storeIds.length; i += storeChunkSize) {
      storeIdsChunks.push(storeIds.slice(i, i + storeChunkSize));
    }

    const chunkPromises = storeIdsChunks.map(storeIdsChunk => api.references.retrieveStocks(nextPageProductIds, storeIdsChunk));

    const stocks = {};

    Promise.allSettled(chunkPromises).then(results => {
      for (const result of results) {
        if (result.status === 'fulfilled') {
          for (const stockInformation of result.value.data.availableStocks) {
            if (!stocks.hasOwnProperty(stockInformation.productReferenceBU)) {
                stocks[stockInformation.productReferenceBU] = {};
            }

            if (!stocks[stockInformation.productReferenceBU].hasOwnProperty(stockInformation.sourcingLocation.id)) {
              stocks[stockInformation.productReferenceBU][stockInformation.sourcingLocation.id] = 0;
            }

            if (stockInformation.availableStockOnHands.length > 0) {
              stocks[stockInformation.productReferenceBU][stockInformation.sourcingLocation.id] = stockInformation.availableStockOnHands[0].availableStockOnHandQuantity;
            }
          }
        } else {
          console.error(result.reason);
        }
      }

      const newFilteredRefs = [];

      this.stocksRef.current = {
        ...this.stocksRef.current,
        ...stocks,
      };

      for (const ref of filteredRefs) {
        const stock = stocks[ref.reference];

        if (!stock) {
          newFilteredRefs.push(ref);
          continue;
        }

        if (stock) {
          ref.stock = [];

          for (const storeId of Object.keys(stock)) {
            ref.stock.push({
              store: Number(storeId),
              qty: stock[storeId]
            });
          }

          newFilteredRefs.push(ref);
        }
      }

      this.setState({
        filteredRefs: newFilteredRefs
      });
    });
  }

  handlePageChange = (page, pageSize) => {
    this.setState({
      currentPage: page,
      pageSize: pageSize
    });

    setTimeout(() => {
      this.handleStockChange();
    });
  }

  render() {
    const self = this
    const rowSelection = {
      selectedRowKeys: self.state.selectedRefs,
      onSelectAll: (selected, selectedRows) => {
        if (selected) {
          let refs = []
          let storesNumber;
          _.forEach(this.filterRefs(), function (obj) {
            storesNumber = numeral(self.getStoresNumberItem(obj.stock)).value();
            if (storesNumber === 0) {
              return;
            }

            refs.push(obj.reference);
          })

          self.setState({
            selectedRefs: refs
          });
        } else {
          self.setState({
            selectedRefs: []
          });
        }
      },
      onSelect: (record, selected) => {
        const index = self.state.selectedRefs.indexOf(record.reference);

        if (selected && index === -1) {
          self.setState({
            selectedRefs: [
              ...self.state.selectedRefs,
              record.reference
            ]
          });
        } else if (!selected && index > -1) {
          const arr = [...self.state.selectedRefs];
          arr.splice(index, 1);
          self.setState({
            selectedRefs: arr
          });
        }
      },
      getCheckboxProps: record => {
        return {
          checked: self.state.selectedRefs.indexOf(record.reference) > -1,
          disabled: !_.get(self.props, 'canSelectRefs', false) || numeral(this.getStoresNumberItem(record.stock)).value() === 0
        };
      }
    };

    return (
      <Fragment>
        <Row gutter={16}>
          <Col span={4}>
            <FormItem label="Ref. LM">
              <Input
                allowClear
                disabled={this.props.references.length === 0}
                placeholder="Filtra per ref. LM"
                value={this.state.refNumFilter}
                onChange={this.setRefNumFilter}
              />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="Descrizione">
              <Input
                allowClear
                disabled={this.props.references.length === 0}
                placeholder="Filtra per descrizione"
                value={this.state.descriptionFilter}
                onChange={this.setDescriptionFilter}
              />
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem label="Gamma">
              <Select
                disabled={this.props.references.length === 0}
                style={{ width: "100%" }}
                value={this.state.gammaFilter}
                onChange={this.setGammaFilter}
              >
                <Select.Option value="">Tutte</Select.Option>
                {gamma.map(letter =>
                  <Select.Option key={letter} value={letter}>{letter}</Select.Option>
                )}
              </Select>
            </FormItem>
          </Col>
        </Row>
        <WhiteTable
          locale={refsTableLocale}
          columns={this.columns}
          dataSource={this.state.filteredRefs}
          size="small"
          rowKey={record => record.reference}
          pagination={{
            current: this.state.currentPage,
            pageSize: this.state.pageSize,
            total: this.state.filteredRefs.length,
            onChange: this.handlePageChange,
          }}
          rowSelection={this.props.canSelectRefs ? rowSelection : null}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    newAgreementStores: state.Agreement.newAgreement.agreementStores,
    selectedAgreementStores: state.Agreement.selectedAgreement.agreementStores,
    newAgreementDetails: state.Agreement.newAgreement.agreementDetails,
    selectedAgreementDetails: state.Agreement.selectedAgreement.agreementDetails
  }
}

export default connect(mapStateToProps, {})(RefsTable)



// WEBPACK FOOTER //
// ./src/components/RefsTable/index.js